import { useEffect, useState } from "react";
import cartimg from "../../assets/logo/icons8-cart-96.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TopHeader from "./TopHeader";
import MobileHeader from "./MobileHeader";
import SideNav from "./SideMenu";
import ShopingCart from "./ShopingCart";
import logo from "../../assets/logo1.png";
import { getLogo } from "../../store/cart/cartAction";
import { baseUrl } from "../../utils/APi";
import SideMenu from "./SideMenu";

const Header = () => {
  const [sideMenu, setSideMenu] = useState(false);
  const handleSide = () => {
    setSideMenu(!sideMenu);
  };
  return (
    <div id="site-header-wrap">
      <TopHeader />
      <header id="site-header">
        <div id="site-header-inner">
          <div className="wrap-inner clearfix">
            <div id="site-logo" className="clearfix">
              <div id="site-log-inner">
                <Link to={"/"} rel="home" className="main-logo">
                  <img src={logo} alt="images" />
                </Link>
              </div>
            </div>
            <div className="mobile-button">
              <span></span>
            </div>
            <MobileHeader />
            <div className="header-menu" onClick={() => handleSide()}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                }}
                href="#"
                className="header-menu-trigger icon-Group-1199"
              ></button>
            </div>
          </div>
          <SideMenu sideMenu={sideMenu} handleSide={handleSide} />
        </div>
      </header>
    </div>
  );
};
export default Header;
